var render, staticRenderFns
import script from "./MaterialAlert.vue?vue&type=script&lang=js"
export * from "./MaterialAlert.vue?vue&type=script&lang=js"
import style0 from "./MaterialAlert.vue?vue&type=style&index=0&id=cbd9b6f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports